import _ from 'lodash';

import {
  imageUtil,
  baseTypes,
  validationUtil
} from 'modules';
import {
  useInvestorsActivityLazyQuery,
  UsersFilterInput
} from 'generated/graphql';

import * as yup from 'yup';
import { listQueryUtil } from 'iron-forge-react-modules';



const __formSchema = yup.object({
  userType: yup.mixed<baseTypes.IUserType>(),
  searchText: yup.string().max(1000),
  isFavorited: yup.boolean(),
  canLeadInvestments: yup.boolean(),
  verifiedByRidge: yup.boolean(),
  investmentCategories: yup.array().of(validationUtil.investmentCategorySchema.required()),
  investmentAreas: yup.array().of(yup.string().uuid().required()),
  investmentStages: yup.array().of(validationUtil.investmentStageSchema.required()),
  investmentGeographies: yup.array().of(validationUtil.investmentGeographySchema.required()),
  city: yup.string(),
  usState: yup.string(),
  country: yup.string()
}).required();



export type IFormData = yup.InferType<typeof __formSchema>;

const useListQuery = listQueryUtil.genUseListQuery();



export interface IData {
  results: ISearchResult[];
}

export interface ISearchResult {
  id: string;
  isFavorited: boolean;
  name: string;
  logoUrl: string;
  description: string;
  websiteUrl: string;
}

export function useInvestorsActivity() {
  const {
    fnQuery,
    queryTuple,
    fnQueryPage,
    pageInfo
  } = useListQuery({
    useLazyQuery: useInvestorsActivityLazyQuery,
    genFilter2GqlFilter: () => __formData2GqlFilter,

    defaultFilterArgs: {},
    clientColumn2GqlSortField: {},
    initQuerySort: {
      columnId: '',
      direction: 'ascending'
    },
    gqlResultData2GqlPageInfo: gqlResultData => gqlResultData?.users.pageInfo,
    gqlResultData2TupleData: (gqlTuple): IData => {
      const favoritedInvestorIds = _.map(gqlTuple.data?.favoritedInvestors ?? [], inv => inv.id);

      return ({
        results: _.map(gqlTuple.data?.users.nodes ?? [], (user): ISearchResult => ({
          id: user.id,
          isFavorited: _.includes(favoritedInvestorIds, user.id),
          description: user.companyProfile?.description ?? '',
          logoUrl: user.companyProfile?.logo?.key ? imageUtil.getFileUrl(user.companyProfile.logo.key) : '',
          name: user.companyProfile?.name ?? '',
          websiteUrl: user.companyProfile?.websiteUrl ?? ''
        }))
      });
    }
  });

  return {
    fnQuery,
    queryTuple,
    fnQueryPage,
    pageInfo
  };
}




function __formData2GqlFilter(formData?: IFormData): UsersFilterInput {
  return formData ? {
    onlyVisible: true,
    userType: 'investor',
    searchText: formData.searchText,
    isFavorited: formData.isFavorited,
    verifiedByRidge: formData.verifiedByRidge,
    canLeadInvestments: formData.canLeadInvestments,
    investmentAreas: formData.investmentAreas,
    investmentCategories: formData.investmentCategories,
    investmentGeographies: formData.investmentGeographies,
    investmentStages: formData.investmentStages,
    city: formData.city,
    usState: formData.usState,
    country: formData.country
  } : {
    userType: 'investor'
  };
}
